export default __webpack_public_path__ + "static/media/IconError.eae67b3e.svg";